import {
  configureStore,
  ThunkAction,
  Action,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import { loadUser, reducer as authReducer } from "redux-oidc-2";
import { userManager } from "../features/auth/authService";

import bettingReducer from "../features/wagers/bettingSlice";
import registrationReducer from "../features/registration/registrationSlice";
import paymentsReducer from "../features/payments/paymentsSlice";
import historyReducer from "../features/history/historySlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    betting: bettingReducer,
    registration: registrationReducer,
    payments: paymentsReducer,
    history: historyReducer,
  },
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
  ],
});

loadUser(store, userManager);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
